import { render, staticRenderFns } from "./MultiChoiceInput.vue?vue&type=template&id=7b95fb28&scoped=true&"
import script from "./MultiChoiceInput.vue?vue&type=script&lang=js&"
export * from "./MultiChoiceInput.vue?vue&type=script&lang=js&"
import style0 from "./MultiChoiceInput.vue?vue&type=style&index=0&id=7b95fb28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b95fb28",
  null
  
)

export default component.exports